import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<circle cx="9" cy="14" r="2"/><path d="M29 6h-.15A88 88 0 0116 7.09 88 88 0 013.15 6H3a1 1 0 00-1 1v18a1 1 0 001 1h.15A88 88 0 0116 24.91 88 88 0 0128.85 26H29a1 1 0 001-1V7a1 1 0 00-1-1zM4 8.2a89.8 89.8 0 0012 .93 89.8 89.8 0 0012-.93v8.4l-2.29-2.34a1 1 0 00-1.42 0L21 17.61l-2.29-2.33a1 1 0 00-1.42 0l-7.75 7.89c-2.22.19-4.17.44-5.54.63zm12 14.67c-1.15 0-2.3 0-3.43.09L18 17.44l3.29 3.35a1 1 0 001.42 0 1 1 0 000-1.44l-.3-.3L25 16.42l3 3.06v4.32a89.8 89.8 0 00-12-.93z"/>';
export var PanoramaOutlineSVG = function PanoramaOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
PanoramaOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PanoramaOutlineSVG);